export const CUSTOMER_SEARCH_MIN_LENGTH = 2;
export const CUSTOMER_SEARCH_DEBOUNCE_MS = 300;
